export enum InstitutionAuditChannel {
  CREATE = 'institutionAudit::create',
  EDIT = 'institutionAudit::patch',
  DELETE = 'institutionAudit::delete',
}
